const e = "@affstore-ds/images", a = "25.4.0";
const i = "module", o = "./dist/affstore-ds-images.umd.cjs", m = "./dist/affstore-ds-images.js", c = "./dist/index.d.ts", n = {
  ".": {
    import: "./dist/affstore-ds-images.js",
    require: "./dist/affstore-ds-images.umd.cjs"
  }
}, f = [
  "/dist",
  "README.md",
  "package.json"
], g = {
  registry: "https://artifactory.quadcode.tech/artifactory/api/npm/npm-aggregate/"
}, t = {
  name: e,
  version: a,
  sideEffects: !1,
  type: i,
  main: o,
  module: m,
  types: c,
  exports: n,
  files: f,
  publishConfig: g
}, d = (s) => `https://static.cdnaffs.com/my/static/libs/affstore-ui-kit/v${t.version}/images/avatar-status/images/images/${s}.png`, r = (s) => `https://static.cdnaffs.com/my/static/libs/affstore-ui-kit/v${t.version}/images/content/images/images/${s}.svg`, p = (s) => `https://static.cdnaffs.com/my/static/libs/affstore-ui-kit/v${t.version}/images/identity/images/images/${s}.svg`, v = (s) => `https://static.cdnaffs.com/my/static/libs/affstore-ui-kit/v${t.version}/images/payment-method/images/images/${s}.svg`, h = (s) => `https://static.cdnaffs.com/my/static/libs/affstore-ui-kit/v${t.version}/images/social/images/images/${s}.svg`;
export {
  d as getAvatarStatusImagePath,
  r as getContentImagePath,
  p as getIdentityImagePath,
  v as getPaymentMethodImagePath,
  h as getSocialImagePath
};
//# sourceMappingURL=affstore-ds-images.js.map
